<template>
    <div class="add-prepared-product-form d-inline-block mb-2 d-inline-flex">
        <input class="form-control" type="text" inputmode="numeric" placeholder="Qté" @change="onChangePreparedQuantityToAdd" @focus="onFocus" v-model="preparedQuantityToAdd" :disabled="isDisabled">
        <input v-if="displayWeight" class="form-control ml-1" type="text" inputmode="decimal" placeholder="Poids" @change="onChangePreparedWeightToAdd" @click="onFocus" v-model="preparedWeightToAdd" :disabled="isDisabled">

        <button v-if="!forceSubmitNeeded" class="btn btn-dark ml-1" @click="onClickAddButton" :disabled="isDisabled">
            Ajouter
        </button>

        <AuthorizationModal
            v-if="forceSubmitNeeded"
            token-type="AddPreparedProductWeightOutOfRange"
            :token-payload="postPayload()"
            @authorised="onAuthorizationModalAuthorize"
        >
            <template #messages>
                <ErrorsZone :errors="errorsSending" />
            </template>
            <template #button="sp">
                <AuthorizationModalButton class="btn-warning ml-1" @click="onClickForceAddButton(sp)">
                    Forcer l'ajout
                </AuthorizationModalButton>
            </template>
        </AuthorizationModal>
    </div>
</template>

<script>
    import AuthorizationModal from "../AuthorizationModal"
    import AuthorizationModalButton from "../AuthorizationModalButton"
    import ErrorsZone from "../ErrorsZone"

    import {usePostRequest} from "../compositions/axios/postRequest";

    export default {
        name: 'AddPreparedProductsForm',

        components: {
            ErrorsZone,
            AuthorizationModal,
            AuthorizationModalButton,
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            product: {
                type: Object,
                required: true,
            },
            displayWeight: {
                type: Boolean,
                required: true,
            },
            disabled: {
                type: Boolean,
                required: false,
            },
        },

        setup() {
            const {
                loading: sending,
                loaded: sent,
                errors: errorsSending,
                post: doPost,
            } = usePostRequest();

            return {
                sending,
                sent,
                errorsSending,
                doPost,
            };
        },

        data() {
            return {
                preparedQuantityToAdd: null,
                preparedWeightToAdd: null,

                forceSubmitNeeded: false,
            };
        },

        methods: {
            onChangePreparedQuantityToAdd(e) {
                const res = parseInt(e.target.value);
                if (isNaN(res)) {
                    this.preparedQuantityToAdd = 0;
                } else {
                    this.preparedQuantityToAdd = res.toString();
                }

                this.forceSubmitNeeded = false;
            },

            onChangePreparedWeightToAdd(e) {
                const res = parseFloat(this.normalizeWeight(e.target.value));
                if (isNaN(res)) {
                    this.preparedWeightToAdd = 0;
                } else {
                    this.preparedWeightToAdd = res.toString().replace('.', ',') ;
                }

                this.forceSubmitNeeded = false;
            },

            formatWeight(weight) {
                if (weight === null) {
                    return 'Non précisé';
                }
                if (weight) {
                    return weight.toString().replace('.', ',') + ' kg';
                }
            },

            normalizeWeight(weight) {
                if (weight) {
                    return parseFloat(weight.toString().replace(',', '.'))
                }
            },

            onClickAddButton() {
                this.addPrepared();
            },

            onClickForceAddButton(sp) {
                sp.showModal();
            },

            postPayload() {
                return {
                    sku: this.product.sku,
                    quantity: this.preparedQuantityToAdd,
                    weight: this.normalizeWeight(this.preparedWeightToAdd),
                };
            },

            async addPrepared(token) {
                this.$emit('submitted');

                let payload = this.postPayload();
                if (token) {
                    payload.authorization_token = token ? token.token : null;
                }

                const response = await this.doPost('/espace-employes/commandes/preparation/commande/' + this.order.id + '/produits-prepares', payload);

                this.$emit('errors', this.errorsSending);

                if (this.errorsSending && this.errorsSending.errors && this.errorsSending.errors.weight) {
                    for (const error of this.errorsSending.errors.weight) {
                        if (error.includes("Le poids ne correspond pas au poids estimé")) {
                            this.forceSubmitNeeded = true;
                        }
                    }
                }

                if (!this.errorsSending) {
                    this.preparedQuantityToAdd = this.preparedWeightToAdd = 0;
                    this.forceSubmitNeeded = false;

                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            },

            onFocus(event) {
                event.target.select();
            },

            async onAuthorizationModalAuthorize(token) {
                await this.addPrepared(token);
            },
        },

        computed: {
            isDisabled() {
                return this.disabled || this.sending;
            },
        }
    }
</script>

<style lang="scss" scoped>
.add-prepared-product-form {
    input {
        text-align: right;
        width: 60px;
    }

    input::placeholder {
        text-align: left;
    }
}
</style>
